module.exports = __webpack_public_path__ + "static/media/tanuja_patil.0c501552.png";